export const FETCH_RATE_LIMITS = "FETCH_RATE_LIMITS";
export const FETCH_RATE_LIMIT = "FETCH_RATE_LIMIT";
export const CREATE_RATE_LIMIT = "CREATE_RATE_LIMIT";
export const UPDATE_RATE_LIMIT = "UPDATE_RATE_LIMIT";
export const DELETE_RATE_LIMIT = "DELETE_RATE_LIMIT";

export function fetchRateLimits(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_RATE_LIMITS,
    auth: true,
    payload: {
      url: "superuser/rate-limits",
      method: "GET",
      params
    }
  };
}

export function fetchRateLimit(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_RATE_LIMIT,
    auth: true,
    payload: {
      url: `superuser/rate-limits/${id}`,
      method: "GET",
      params
    }
  };
}

export function createRateLimit(data = {}) {
  return {
    type: CREATE_RATE_LIMIT,
    auth: true,
    payload: {
      url: "superuser/rate-limits",
      method: "POST",
      data
    }
  };
}

export function updateRateLimit(id, data = {}) {
  return {
    type: UPDATE_RATE_LIMIT,
    auth: true,
    payload: {
      url: `superuser/rate-limits/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteRateLimit(id, data = {}) {
  return {
    type: DELETE_RATE_LIMIT,
    auth: true,
    payload: {
      url: `superuser/rate-limits/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/rateLimit.js